import {IPokeDex} from '../Types'

const NatDex : IPokeDex[] = 
[
{'dex' : 1, 'pokemon' : 'Bulbasaur'},
{'dex' : 2, 'pokemon' : 'Ivysaur'},
{'dex' : 3, 'pokemon' : 'Venusaur'},
{'dex' : 4, 'pokemon' : 'Charmander'},
{'dex' : 5, 'pokemon' : 'Charmeleon'},
{'dex' : 6, 'pokemon' : 'Charizard'},
{'dex' : 7, 'pokemon' : 'Squirtle'},
{'dex' : 8, 'pokemon' : 'Wartortle'},
{'dex' : 9, 'pokemon' : 'Blastoise'},
{'dex' : 10, 'pokemon' : 'Caterpie'},
{'dex' : 11, 'pokemon' : 'Metapod'},
{'dex' : 12, 'pokemon' : 'Butterfree'},
{'dex' : 13, 'pokemon' : 'Weedle'},
{'dex' : 14, 'pokemon' : 'Kakuna'},
{'dex' : 15, 'pokemon' : 'Beedrill'},
{'dex' : 16, 'pokemon' : 'Pidgey'},
{'dex' : 17, 'pokemon' : 'Pidgeotto'},
{'dex' : 18, 'pokemon' : 'Pidgeot'},
{'dex' : 19, 'pokemon' : 'Rattata'},
{'dex' : 20, 'pokemon' : 'Raticate'},
{'dex' : 21, 'pokemon' : 'Spearow'},
{'dex' : 22, 'pokemon' : 'Fearow'},
{'dex' : 23, 'pokemon' : 'Ekans'},
{'dex' : 24, 'pokemon' : 'Arbok'},
{'dex' : 25, 'pokemon' : 'Pikachu'},
{'dex' : 26, 'pokemon' : 'Raichu'},
{'dex' : 27, 'pokemon' : 'Sandshrew'},
{'dex' : 28, 'pokemon' : 'Sandslash'},
{'dex' : 29, 'pokemon' : 'Nidoran♀'},
{'dex' : 30, 'pokemon' : 'Nidorina'},
{'dex' : 31, 'pokemon' : 'Nidoqueen'},
{'dex' : 32, 'pokemon' : 'Nidoran♂'},
{'dex' : 33, 'pokemon' : 'Nidorino'},
{'dex' : 34, 'pokemon' : 'Nidoking'},
{'dex' : 35, 'pokemon' : 'Clefairy'},
{'dex' : 36, 'pokemon' : 'Clefable'},
{'dex' : 37, 'pokemon' : 'Vulpix'},
{'dex' : 38, 'pokemon' : 'Ninetales'},
{'dex' : 39, 'pokemon' : 'Jigglypuff'},
{'dex' : 40, 'pokemon' : 'Wigglytuff'},
{'dex' : 41, 'pokemon' : 'Zubat'},
{'dex' : 42, 'pokemon' : 'Golbat'},
{'dex' : 43, 'pokemon' : 'Oddish'},
{'dex' : 44, 'pokemon' : 'Gloom'},
{'dex' : 45, 'pokemon' : 'Vileplume'},
{'dex' : 46, 'pokemon' : 'Paras'},
{'dex' : 47, 'pokemon' : 'Parasect'},
{'dex' : 48, 'pokemon' : 'Venonat'},
{'dex' : 49, 'pokemon' : 'Venomoth'},
{'dex' : 50, 'pokemon' : 'Diglett'},
{'dex' : 51, 'pokemon' : 'Dugtrio'},
{'dex' : 52, 'pokemon' : 'Meowth'},
{'dex' : 53, 'pokemon' : 'Persian'},
{'dex' : 54, 'pokemon' : 'Psyduck'},
{'dex' : 55, 'pokemon' : 'Golduck'},
{'dex' : 56, 'pokemon' : 'Mankey'},
{'dex' : 57, 'pokemon' : 'Primeape'},
{'dex' : 58, 'pokemon' : 'Growlithe'},
{'dex' : 59, 'pokemon' : 'Arcanine'},
{'dex' : 60, 'pokemon' : 'Poliwag'},
{'dex' : 61, 'pokemon' : 'Poliwhirl'},
{'dex' : 62, 'pokemon' : 'Poliwrath'},
{'dex' : 63, 'pokemon' : 'Abra'},
{'dex' : 64, 'pokemon' : 'Kadabra'},
{'dex' : 65, 'pokemon' : 'Alakazam'},
{'dex' : 66, 'pokemon' : 'Machop'},
{'dex' : 67, 'pokemon' : 'Machoke'},
{'dex' : 68, 'pokemon' : 'Machamp'},
{'dex' : 69, 'pokemon' : 'Bellsprout'},
{'dex' : 70, 'pokemon' : 'Weepinbell'},
{'dex' : 71, 'pokemon' : 'Victreebel'},
{'dex' : 72, 'pokemon' : 'Tentacool'},
{'dex' : 73, 'pokemon' : 'Tentacruel'},
{'dex' : 74, 'pokemon' : 'Geodude'},
{'dex' : 75, 'pokemon' : 'Graveler'},
{'dex' : 76, 'pokemon' : 'Golem'},
{'dex' : 77, 'pokemon' : 'Ponyta'},
{'dex' : 78, 'pokemon' : 'Rapidash'},
{'dex' : 79, 'pokemon' : 'Slowpoke'},
{'dex' : 80, 'pokemon' : 'Slowbro'},
{'dex' : 81, 'pokemon' : 'Magnemite'},
{'dex' : 82, 'pokemon' : 'Magneton'},
{'dex' : 83, 'pokemon' : 'Farfetch’d'},
{'dex' : 84, 'pokemon' : 'Doduo'},
{'dex' : 85, 'pokemon' : 'Dodrio'},
{'dex' : 86, 'pokemon' : 'Seel'},
{'dex' : 87, 'pokemon' : 'Dewgong'},
{'dex' : 88, 'pokemon' : 'Grimer'},
{'dex' : 89, 'pokemon' : 'Muk'},
{'dex' : 90, 'pokemon' : 'Shellder'},
{'dex' : 91, 'pokemon' : 'Cloyster'},
{'dex' : 92, 'pokemon' : 'Gastly'},
{'dex' : 93, 'pokemon' : 'Haunter'},
{'dex' : 94, 'pokemon' : 'Gengar'},
{'dex' : 95, 'pokemon' : 'Onix'},
{'dex' : 96, 'pokemon' : 'Drowzee'},
{'dex' : 97, 'pokemon' : 'Hypno'},
{'dex' : 98, 'pokemon' : 'Krabby'},
{'dex' : 99, 'pokemon' : 'Kingler'},
{'dex' : 100, 'pokemon' : 'Voltorb'},
{'dex' : 101, 'pokemon' : 'Electrode'},
{'dex' : 102, 'pokemon' : 'Exeggcute'},
{'dex' : 103, 'pokemon' : 'Exeggutor'},
{'dex' : 104, 'pokemon' : 'Cubone'},
{'dex' : 105, 'pokemon' : 'Marowak'},
{'dex' : 106, 'pokemon' : 'Hitmonlee'},
{'dex' : 107, 'pokemon' : 'Hitmonchan'},
{'dex' : 108, 'pokemon' : 'Lickitung'},
{'dex' : 109, 'pokemon' : 'Koffing'},
{'dex' : 110, 'pokemon' : 'Weezing'},
{'dex' : 111, 'pokemon' : 'Rhyhorn'},
{'dex' : 112, 'pokemon' : 'Rhydon'},
{'dex' : 113, 'pokemon' : 'Chansey'},
{'dex' : 114, 'pokemon' : 'Tangela'},
{'dex' : 115, 'pokemon' : 'Kangaskhan'},
{'dex' : 116, 'pokemon' : 'Horsea'},
{'dex' : 117, 'pokemon' : 'Seadra'},
{'dex' : 118, 'pokemon' : 'Goldeen'},
{'dex' : 119, 'pokemon' : 'Seaking'},
{'dex' : 120, 'pokemon' : 'Staryu'},
{'dex' : 121, 'pokemon' : 'Starmie'},
{'dex' : 122, 'pokemon' : 'Mr. Mime'},
{'dex' : 123, 'pokemon' : 'Scyther'},
{'dex' : 124, 'pokemon' : 'Jynx'},
{'dex' : 125, 'pokemon' : 'Electabuzz'},
{'dex' : 126, 'pokemon' : 'Magmar'},
{'dex' : 127, 'pokemon' : 'Pinsir'},
{'dex' : 128, 'pokemon' : 'Tauros'},
{'dex' : 129, 'pokemon' : 'Magikarp'},
{'dex' : 130, 'pokemon' : 'Gyarados'},
{'dex' : 131, 'pokemon' : 'Lapras'},
{'dex' : 132, 'pokemon' : 'Ditto'},
{'dex' : 133, 'pokemon' : 'Eevee'},
{'dex' : 134, 'pokemon' : 'Vaporeon'},
{'dex' : 135, 'pokemon' : 'Jolteon'},
{'dex' : 136, 'pokemon' : 'Flareon'},
{'dex' : 137, 'pokemon' : 'Porygon'},
{'dex' : 138, 'pokemon' : 'Omanyte'},
{'dex' : 139, 'pokemon' : 'Omastar'},
{'dex' : 140, 'pokemon' : 'Kabuto'},
{'dex' : 141, 'pokemon' : 'Kabutops'},
{'dex' : 142, 'pokemon' : 'Aerodactyl'},
{'dex' : 143, 'pokemon' : 'Snorlax'},
{'dex' : 144, 'pokemon' : 'Articuno'},
{'dex' : 145, 'pokemon' : 'Zapdos'},
{'dex' : 146, 'pokemon' : 'Moltres'},
{'dex' : 147, 'pokemon' : 'Dratini'},
{'dex' : 148, 'pokemon' : 'Dragonair'},
{'dex' : 149, 'pokemon' : 'Dragonite'},
{'dex' : 150, 'pokemon' : 'Mewtwo'},
{'dex' : 151, 'pokemon' : 'Mew'},
{'dex' : 152, 'pokemon' : 'Chikorita'},
{'dex' : 153, 'pokemon' : 'Bayleef'},
{'dex' : 154, 'pokemon' : 'Meganium'},
{'dex' : 155, 'pokemon' : 'Cyndaquil'},
{'dex' : 156, 'pokemon' : 'Quilava'},
{'dex' : 157, 'pokemon' : 'Typhlosion'},
{'dex' : 158, 'pokemon' : 'Totodile'},
{'dex' : 159, 'pokemon' : 'Croconaw'},
{'dex' : 160, 'pokemon' : 'Feraligatr'},
{'dex' : 161, 'pokemon' : 'Sentret'},
{'dex' : 162, 'pokemon' : 'Furret'},
{'dex' : 163, 'pokemon' : 'Hoothoot'},
{'dex' : 164, 'pokemon' : 'Noctowl'},
{'dex' : 165, 'pokemon' : 'Ledyba'},
{'dex' : 166, 'pokemon' : 'Ledian'},
{'dex' : 167, 'pokemon' : 'Spinarak'},
{'dex' : 168, 'pokemon' : 'Ariados'},
{'dex' : 169, 'pokemon' : 'Crobat'},
{'dex' : 170, 'pokemon' : 'Chinchou'},
{'dex' : 171, 'pokemon' : 'Lanturn'},
{'dex' : 172, 'pokemon' : 'Pichu'},
{'dex' : 173, 'pokemon' : 'Cleffa'},
{'dex' : 174, 'pokemon' : 'Igglybuff'},
{'dex' : 175, 'pokemon' : 'Togepi'},
{'dex' : 176, 'pokemon' : 'Togetic'},
{'dex' : 177, 'pokemon' : 'Natu'},
{'dex' : 178, 'pokemon' : 'Xatu'},
{'dex' : 179, 'pokemon' : 'Mareep'},
{'dex' : 180, 'pokemon' : 'Flaaffy'},
{'dex' : 181, 'pokemon' : 'Ampharos'},
{'dex' : 182, 'pokemon' : 'Bellossom'},
{'dex' : 183, 'pokemon' : 'Marill'},
{'dex' : 184, 'pokemon' : 'Azumarill'},
{'dex' : 185, 'pokemon' : 'Sudowoodo'},
{'dex' : 186, 'pokemon' : 'Politoed'},
{'dex' : 187, 'pokemon' : 'Hoppip'},
{'dex' : 188, 'pokemon' : 'Skiploom'},
{'dex' : 189, 'pokemon' : 'Jumpluff'},
{'dex' : 190, 'pokemon' : 'Aipom'},
{'dex' : 191, 'pokemon' : 'Sunkern'},
{'dex' : 192, 'pokemon' : 'Sunflora'},
{'dex' : 193, 'pokemon' : 'Yanma'},
{'dex' : 194, 'pokemon' : 'Wooper'},
{'dex' : 195, 'pokemon' : 'Quagsire'},
{'dex' : 196, 'pokemon' : 'Espeon'},
{'dex' : 197, 'pokemon' : 'Umbreon'},
{'dex' : 198, 'pokemon' : 'Murkrow'},
{'dex' : 199, 'pokemon' : 'Slowking'},
{'dex' : 200, 'pokemon' : 'Misdreavus'},
{'dex' : 201, 'pokemon' : 'Unown'},
{'dex' : 202, 'pokemon' : 'Wobbuffet'},
{'dex' : 203, 'pokemon' : 'Girafarig'},
{'dex' : 204, 'pokemon' : 'Pineco'},
{'dex' : 205, 'pokemon' : 'Forretress'},
{'dex' : 206, 'pokemon' : 'Dunsparce'},
{'dex' : 207, 'pokemon' : 'Gligar'},
{'dex' : 208, 'pokemon' : 'Steelix'},
{'dex' : 209, 'pokemon' : 'Snubbull'},
{'dex' : 210, 'pokemon' : 'Granbull'},
{'dex' : 211, 'pokemon' : 'Qwilfish'},
{'dex' : 212, 'pokemon' : 'Scizor'},
{'dex' : 213, 'pokemon' : 'Shuckle'},
{'dex' : 214, 'pokemon' : 'Heracross'},
{'dex' : 215, 'pokemon' : 'Sneasel'},
{'dex' : 216, 'pokemon' : 'Teddiursa'},
{'dex' : 217, 'pokemon' : 'Ursaring'},
{'dex' : 218, 'pokemon' : 'Slugma'},
{'dex' : 219, 'pokemon' : 'Magcargo'},
{'dex' : 220, 'pokemon' : 'Swinub'},
{'dex' : 221, 'pokemon' : 'Piloswine'},
{'dex' : 222, 'pokemon' : 'Corsola'},
{'dex' : 223, 'pokemon' : 'Remoraid'},
{'dex' : 224, 'pokemon' : 'Octillery'},
{'dex' : 225, 'pokemon' : 'Delibird'},
{'dex' : 226, 'pokemon' : 'Mantine'},
{'dex' : 227, 'pokemon' : 'Skarmory'},
{'dex' : 228, 'pokemon' : 'Houndour'},
{'dex' : 229, 'pokemon' : 'Houndoom'},
{'dex' : 230, 'pokemon' : 'Kingdra'},
{'dex' : 231, 'pokemon' : 'Phanpy'},
{'dex' : 232, 'pokemon' : 'Donphan'},
{'dex' : 233, 'pokemon' : 'Porygon2'},
{'dex' : 234, 'pokemon' : 'Stantler'},
{'dex' : 235, 'pokemon' : 'Smeargle'},
{'dex' : 236, 'pokemon' : 'Tyrogue'},
{'dex' : 237, 'pokemon' : 'Hitmontop'},
{'dex' : 238, 'pokemon' : 'Smoochum'},
{'dex' : 239, 'pokemon' : 'Elekid'},
{'dex' : 240, 'pokemon' : 'Magby'},
{'dex' : 241, 'pokemon' : 'Miltank'},
{'dex' : 242, 'pokemon' : 'Blissey'},
{'dex' : 243, 'pokemon' : 'Raikou'},
{'dex' : 244, 'pokemon' : 'Entei'},
{'dex' : 245, 'pokemon' : 'Suicune'},
{'dex' : 246, 'pokemon' : 'Larvitar'},
{'dex' : 247, 'pokemon' : 'Pupitar'},
{'dex' : 248, 'pokemon' : 'Tyranitar'},
{'dex' : 249, 'pokemon' : 'Lugia'},
{'dex' : 250, 'pokemon' : 'Ho-Oh'},
{'dex' : 251, 'pokemon' : 'Celebi'},
{'dex' : 252, 'pokemon' : 'Treecko'},
{'dex' : 253, 'pokemon' : 'Grovyle'},
{'dex' : 254, 'pokemon' : 'Sceptile'},
{'dex' : 255, 'pokemon' : 'Torchic'},
{'dex' : 256, 'pokemon' : 'Combusken'},
{'dex' : 257, 'pokemon' : 'Blaziken'},
{'dex' : 258, 'pokemon' : 'Mudkip'},
{'dex' : 259, 'pokemon' : 'Marshtomp'},
{'dex' : 260, 'pokemon' : 'Swampert'},
{'dex' : 261, 'pokemon' : 'Poochyena'},
{'dex' : 262, 'pokemon' : 'Mightyena'},
{'dex' : 263, 'pokemon' : 'Zigzagoon'},
{'dex' : 264, 'pokemon' : 'Linoone'},
{'dex' : 265, 'pokemon' : 'Wurmple'},
{'dex' : 266, 'pokemon' : 'Silcoon'},
{'dex' : 267, 'pokemon' : 'Beautifly'},
{'dex' : 268, 'pokemon' : 'Cascoon'},
{'dex' : 269, 'pokemon' : 'Dustox'},
{'dex' : 270, 'pokemon' : 'Lotad'},
{'dex' : 271, 'pokemon' : 'Lombre'},
{'dex' : 272, 'pokemon' : 'Ludicolo'},
{'dex' : 273, 'pokemon' : 'Seedot'},
{'dex' : 274, 'pokemon' : 'Nuzleaf'},
{'dex' : 275, 'pokemon' : 'Shiftry'},
{'dex' : 276, 'pokemon' : 'Taillow'},
{'dex' : 277, 'pokemon' : 'Swellow'},
{'dex' : 278, 'pokemon' : 'Wingull'},
{'dex' : 279, 'pokemon' : 'Pelipper'},
{'dex' : 280, 'pokemon' : 'Ralts'},
{'dex' : 281, 'pokemon' : 'Kirlia'},
{'dex' : 282, 'pokemon' : 'Gardevoir'},
{'dex' : 283, 'pokemon' : 'Surskit'},
{'dex' : 284, 'pokemon' : 'Masquerain'},
{'dex' : 285, 'pokemon' : 'Shroomish'},
{'dex' : 286, 'pokemon' : 'Breloom'},
{'dex' : 287, 'pokemon' : 'Slakoth'},
{'dex' : 288, 'pokemon' : 'Vigoroth'},
{'dex' : 289, 'pokemon' : 'Slaking'},
{'dex' : 290, 'pokemon' : 'Nincada'},
{'dex' : 291, 'pokemon' : 'Ninjask'},
{'dex' : 292, 'pokemon' : 'Shedinja'},
{'dex' : 293, 'pokemon' : 'Whismur'},
{'dex' : 294, 'pokemon' : 'Loudred'},
{'dex' : 295, 'pokemon' : 'Exploud'},
{'dex' : 296, 'pokemon' : 'Makuhita'},
{'dex' : 297, 'pokemon' : 'Hariyama'},
{'dex' : 298, 'pokemon' : 'Azurill'},
{'dex' : 299, 'pokemon' : 'Nosepass'},
{'dex' : 300, 'pokemon' : 'Skitty'},
{'dex' : 301, 'pokemon' : 'Delcatty'},
{'dex' : 302, 'pokemon' : 'Sableye'},
{'dex' : 303, 'pokemon' : 'Mawile'},
{'dex' : 304, 'pokemon' : 'Aron'},
{'dex' : 305, 'pokemon' : 'Lairon'},
{'dex' : 306, 'pokemon' : 'Aggron'},
{'dex' : 307, 'pokemon' : 'Meditite'},
{'dex' : 308, 'pokemon' : 'Medicham'},
{'dex' : 309, 'pokemon' : 'Electrike'},
{'dex' : 310, 'pokemon' : 'Manectric'},
{'dex' : 311, 'pokemon' : 'Plusle'},
{'dex' : 312, 'pokemon' : 'Minun'},
{'dex' : 313, 'pokemon' : 'Volbeat'},
{'dex' : 314, 'pokemon' : 'Illumise'},
{'dex' : 315, 'pokemon' : 'Roselia'},
{'dex' : 316, 'pokemon' : 'Gulpin'},
{'dex' : 317, 'pokemon' : 'Swalot'},
{'dex' : 318, 'pokemon' : 'Carvanha'},
{'dex' : 319, 'pokemon' : 'Sharpedo'},
{'dex' : 320, 'pokemon' : 'Wailmer'},
{'dex' : 321, 'pokemon' : 'Wailord'},
{'dex' : 322, 'pokemon' : 'Numel'},
{'dex' : 323, 'pokemon' : 'Camerupt'},
{'dex' : 324, 'pokemon' : 'Torkoal'},
{'dex' : 325, 'pokemon' : 'Spoink'},
{'dex' : 326, 'pokemon' : 'Grumpig'},
{'dex' : 327, 'pokemon' : 'Spinda'},
{'dex' : 328, 'pokemon' : 'Trapinch'},
{'dex' : 329, 'pokemon' : 'Vibrava'},
{'dex' : 330, 'pokemon' : 'Flygon'},
{'dex' : 331, 'pokemon' : 'Cacnea'},
{'dex' : 332, 'pokemon' : 'Cacturne'},
{'dex' : 333, 'pokemon' : 'Swablu'},
{'dex' : 334, 'pokemon' : 'Altaria'},
{'dex' : 335, 'pokemon' : 'Zangoose'},
{'dex' : 336, 'pokemon' : 'Seviper'},
{'dex' : 337, 'pokemon' : 'Lunatone'},
{'dex' : 338, 'pokemon' : 'Solrock'},
{'dex' : 339, 'pokemon' : 'Barboach'},
{'dex' : 340, 'pokemon' : 'Whiscash'},
{'dex' : 341, 'pokemon' : 'Corphish'},
{'dex' : 342, 'pokemon' : 'Crawdaunt'},
{'dex' : 343, 'pokemon' : 'Baltoy'},
{'dex' : 344, 'pokemon' : 'Claydol'},
{'dex' : 345, 'pokemon' : 'Lileep'},
{'dex' : 346, 'pokemon' : 'Cradily'},
{'dex' : 347, 'pokemon' : 'Anorith'},
{'dex' : 348, 'pokemon' : 'Armaldo'},
{'dex' : 349, 'pokemon' : 'Feebas'},
{'dex' : 350, 'pokemon' : 'Milotic'},
{'dex' : 351, 'pokemon' : 'Castform'},
{'dex' : 352, 'pokemon' : 'Kecleon'},
{'dex' : 353, 'pokemon' : 'Shuppet'},
{'dex' : 354, 'pokemon' : 'Banette'},
{'dex' : 355, 'pokemon' : 'Duskull'},
{'dex' : 356, 'pokemon' : 'Dusclops'},
{'dex' : 357, 'pokemon' : 'Tropius'},
{'dex' : 358, 'pokemon' : 'Chimecho'},
{'dex' : 359, 'pokemon' : 'Absol'},
{'dex' : 360, 'pokemon' : 'Wynaut'},
{'dex' : 361, 'pokemon' : 'Snorunt'},
{'dex' : 362, 'pokemon' : 'Glalie'},
{'dex' : 363, 'pokemon' : 'Spheal'},
{'dex' : 364, 'pokemon' : 'Sealeo'},
{'dex' : 365, 'pokemon' : 'Walrein'},
{'dex' : 366, 'pokemon' : 'Clamperl'},
{'dex' : 367, 'pokemon' : 'Huntail'},
{'dex' : 368, 'pokemon' : 'Gorebyss'},
{'dex' : 369, 'pokemon' : 'Relicanth'},
{'dex' : 370, 'pokemon' : 'Luvdisc'},
{'dex' : 371, 'pokemon' : 'Bagon'},
{'dex' : 372, 'pokemon' : 'Shelgon'},
{'dex' : 373, 'pokemon' : 'Salamence'},
{'dex' : 374, 'pokemon' : 'Beldum'},
{'dex' : 375, 'pokemon' : 'Metang'},
{'dex' : 376, 'pokemon' : 'Metagross'},
{'dex' : 377, 'pokemon' : 'Regirock'},
{'dex' : 378, 'pokemon' : 'Regice'},
{'dex' : 379, 'pokemon' : 'Registeel'},
{'dex' : 380, 'pokemon' : 'Latias'},
{'dex' : 381, 'pokemon' : 'Latios'},
{'dex' : 382, 'pokemon' : 'Kyogre'},
{'dex' : 383, 'pokemon' : 'Groudon'},
{'dex' : 384, 'pokemon' : 'Rayquaza'},
{'dex' : 385, 'pokemon' : 'Jirachi'},
{'dex' : 386, 'pokemon' : 'Deoxys'},
{'dex' : 387, 'pokemon' : 'Turtwig'},
{'dex' : 388, 'pokemon' : 'Grotle'},
{'dex' : 389, 'pokemon' : 'Torterra'},
{'dex' : 390, 'pokemon' : 'Chimchar'},
{'dex' : 391, 'pokemon' : 'Monferno'},
{'dex' : 392, 'pokemon' : 'Infernape'},
{'dex' : 393, 'pokemon' : 'Piplup'},
{'dex' : 394, 'pokemon' : 'Prinplup'},
{'dex' : 395, 'pokemon' : 'Empoleon'},
{'dex' : 396, 'pokemon' : 'Starly'},
{'dex' : 397, 'pokemon' : 'Staravia'},
{'dex' : 398, 'pokemon' : 'Staraptor'},
{'dex' : 399, 'pokemon' : 'Bidoof'},
{'dex' : 400, 'pokemon' : 'Bibarel'},
{'dex' : 401, 'pokemon' : 'Kricketot'},
{'dex' : 402, 'pokemon' : 'Kricketune'},
{'dex' : 403, 'pokemon' : 'Shinx'},
{'dex' : 404, 'pokemon' : 'Luxio'},
{'dex' : 405, 'pokemon' : 'Luxray'},
{'dex' : 406, 'pokemon' : 'Budew'},
{'dex' : 407, 'pokemon' : 'Roserade'},
{'dex' : 408, 'pokemon' : 'Cranidos'},
{'dex' : 409, 'pokemon' : 'Rampardos'},
{'dex' : 410, 'pokemon' : 'Shieldon'},
{'dex' : 411, 'pokemon' : 'Bastiodon'},
{'dex' : 412, 'pokemon' : 'Burmy'},
{'dex' : 413, 'pokemon' : 'Wormadam'},
{'dex' : 414, 'pokemon' : 'Mothim'},
{'dex' : 415, 'pokemon' : 'Combee'},
{'dex' : 416, 'pokemon' : 'Vespiquen'},
{'dex' : 417, 'pokemon' : 'Pachirisu'},
{'dex' : 418, 'pokemon' : 'Buizel'},
{'dex' : 419, 'pokemon' : 'Floatzel'},
{'dex' : 420, 'pokemon' : 'Cherubi'},
{'dex' : 421, 'pokemon' : 'Cherrim'},
{'dex' : 422, 'pokemon' : 'Shellos'},
{'dex' : 423, 'pokemon' : 'Gastrodon'},
{'dex' : 424, 'pokemon' : 'Ambipom'},
{'dex' : 425, 'pokemon' : 'Drifloon'},
{'dex' : 426, 'pokemon' : 'Drifblim'},
{'dex' : 427, 'pokemon' : 'Buneary'},
{'dex' : 428, 'pokemon' : 'Lopunny'},
{'dex' : 429, 'pokemon' : 'Mismagius'},
{'dex' : 430, 'pokemon' : 'Honchkrow'},
{'dex' : 431, 'pokemon' : 'Glameow'},
{'dex' : 432, 'pokemon' : 'Purugly'},
{'dex' : 433, 'pokemon' : 'Chingling'},
{'dex' : 434, 'pokemon' : 'Stunky'},
{'dex' : 435, 'pokemon' : 'Skuntank'},
{'dex' : 436, 'pokemon' : 'Bronzor'},
{'dex' : 437, 'pokemon' : 'Bronzong'},
{'dex' : 438, 'pokemon' : 'Bonsly'},
{'dex' : 439, 'pokemon' : 'Mime Jr.'},
{'dex' : 440, 'pokemon' : 'Happiny'},
{'dex' : 441, 'pokemon' : 'Chatot'},
{'dex' : 442, 'pokemon' : 'Spiritomb'},
{'dex' : 443, 'pokemon' : 'Gible'},
{'dex' : 444, 'pokemon' : 'Gabite'},
{'dex' : 445, 'pokemon' : 'Garchomp'},
{'dex' : 446, 'pokemon' : 'Munchlax'},
{'dex' : 447, 'pokemon' : 'Riolu'},
{'dex' : 448, 'pokemon' : 'Lucario'},
{'dex' : 449, 'pokemon' : 'Hippopotas'},
{'dex' : 450, 'pokemon' : 'Hippowdon'},
{'dex' : 451, 'pokemon' : 'Skorupi'},
{'dex' : 452, 'pokemon' : 'Drapion'},
{'dex' : 453, 'pokemon' : 'Croagunk'},
{'dex' : 454, 'pokemon' : 'Toxicroak'},
{'dex' : 455, 'pokemon' : 'Carnivine'},
{'dex' : 456, 'pokemon' : 'Finneon'},
{'dex' : 457, 'pokemon' : 'Lumineon'},
{'dex' : 458, 'pokemon' : 'Mantyke'},
{'dex' : 459, 'pokemon' : 'Snover'},
{'dex' : 460, 'pokemon' : 'Abomasnow'},
{'dex' : 461, 'pokemon' : 'Weavile'},
{'dex' : 462, 'pokemon' : 'Magnezone'},
{'dex' : 463, 'pokemon' : 'Lickilicky'},
{'dex' : 464, 'pokemon' : 'Rhyperior'},
{'dex' : 465, 'pokemon' : 'Tangrowth'},
{'dex' : 466, 'pokemon' : 'Electivire'},
{'dex' : 467, 'pokemon' : 'Magmortar'},
{'dex' : 468, 'pokemon' : 'Togekiss'},
{'dex' : 469, 'pokemon' : 'Yanmega'},
{'dex' : 470, 'pokemon' : 'Leafeon'},
{'dex' : 471, 'pokemon' : 'Glaceon'},
{'dex' : 472, 'pokemon' : 'Gliscor'},
{'dex' : 473, 'pokemon' : 'Mamoswine'},
{'dex' : 474, 'pokemon' : 'Porygon-Z'},
{'dex' : 475, 'pokemon' : 'Gallade'},
{'dex' : 476, 'pokemon' : 'Probopass'},
{'dex' : 477, 'pokemon' : 'Dusknoir'},
{'dex' : 478, 'pokemon' : 'Froslass'},
{'dex' : 479, 'pokemon' : 'Rotom'},
{'dex' : 480, 'pokemon' : 'Uxie'},
{'dex' : 481, 'pokemon' : 'Mesprit'},
{'dex' : 482, 'pokemon' : 'Azelf'},
{'dex' : 483, 'pokemon' : 'Dialga'},
{'dex' : 484, 'pokemon' : 'Palkia'},
{'dex' : 485, 'pokemon' : 'Heatran'},
{'dex' : 486, 'pokemon' : 'Regigigas'},
{'dex' : 487, 'pokemon' : 'Giratina'},
{'dex' : 488, 'pokemon' : 'Cresselia'},
{'dex' : 489, 'pokemon' : 'Phione'},
{'dex' : 490, 'pokemon' : 'Manaphy'},
{'dex' : 491, 'pokemon' : 'Darkrai'},
{'dex' : 492, 'pokemon' : 'Shaymin'},
{'dex' : 493, 'pokemon' : 'Arceus'},
{'dex' : 494, 'pokemon' : 'Victini'},
{'dex' : 495, 'pokemon' : 'Snivy'},
{'dex' : 496, 'pokemon' : 'Servine'},
{'dex' : 497, 'pokemon' : 'Serperior'},
{'dex' : 498, 'pokemon' : 'Tepig'},
{'dex' : 499, 'pokemon' : 'Pignite'},
{'dex' : 500, 'pokemon' : 'Emboar'},
{'dex' : 501, 'pokemon' : 'Oshawott'},
{'dex' : 502, 'pokemon' : 'Dewott'},
{'dex' : 503, 'pokemon' : 'Samurott'},
{'dex' : 504, 'pokemon' : 'Patrat'},
{'dex' : 505, 'pokemon' : 'Watchog'},
{'dex' : 506, 'pokemon' : 'Lillipup'},
{'dex' : 507, 'pokemon' : 'Herdier'},
{'dex' : 508, 'pokemon' : 'Stoutland'},
{'dex' : 509, 'pokemon' : 'Purrloin'},
{'dex' : 510, 'pokemon' : 'Liepard'},
{'dex' : 511, 'pokemon' : 'Pansage'},
{'dex' : 512, 'pokemon' : 'Simisage'},
{'dex' : 513, 'pokemon' : 'Pansear'},
{'dex' : 514, 'pokemon' : 'Simisear'},
{'dex' : 515, 'pokemon' : 'Panpour'},
{'dex' : 516, 'pokemon' : 'Simipour'},
{'dex' : 517, 'pokemon' : 'Munna'},
{'dex' : 518, 'pokemon' : 'Musharna'},
{'dex' : 519, 'pokemon' : 'Pidove'},
{'dex' : 520, 'pokemon' : 'Tranquill'},
{'dex' : 521, 'pokemon' : 'Unfezant'},
{'dex' : 522, 'pokemon' : 'Blitzle'},
{'dex' : 523, 'pokemon' : 'Zebstrika'},
{'dex' : 524, 'pokemon' : 'Roggenrola'},
{'dex' : 525, 'pokemon' : 'Boldore'},
{'dex' : 526, 'pokemon' : 'Gigalith'},
{'dex' : 527, 'pokemon' : 'Woobat'},
{'dex' : 528, 'pokemon' : 'Swoobat'},
{'dex' : 529, 'pokemon' : 'Drilbur'},
{'dex' : 530, 'pokemon' : 'Excadrill'},
{'dex' : 531, 'pokemon' : 'Audino'},
{'dex' : 532, 'pokemon' : 'Timburr'},
{'dex' : 533, 'pokemon' : 'Gurdurr'},
{'dex' : 534, 'pokemon' : 'Conkeldurr'},
{'dex' : 535, 'pokemon' : 'Tympole'},
{'dex' : 536, 'pokemon' : 'Palpitoad'},
{'dex' : 537, 'pokemon' : 'Seismitoad'},
{'dex' : 538, 'pokemon' : 'Throh'},
{'dex' : 539, 'pokemon' : 'Sawk'},
{'dex' : 540, 'pokemon' : 'Sewaddle'},
{'dex' : 541, 'pokemon' : 'Swadloon'},
{'dex' : 542, 'pokemon' : 'Leavanny'},
{'dex' : 543, 'pokemon' : 'Venipede'},
{'dex' : 544, 'pokemon' : 'Whirlipede'},
{'dex' : 545, 'pokemon' : 'Scolipede'},
{'dex' : 546, 'pokemon' : 'Cottonee'},
{'dex' : 547, 'pokemon' : 'Whimsicott'},
{'dex' : 548, 'pokemon' : 'Petilil'},
{'dex' : 549, 'pokemon' : 'Lilligant'},
{'dex' : 550, 'pokemon' : 'Basculin'},
{'dex' : 551, 'pokemon' : 'Sandile'},
{'dex' : 552, 'pokemon' : 'Krokorok'},
{'dex' : 553, 'pokemon' : 'Krookodile'},
{'dex' : 554, 'pokemon' : 'Darumaka'},
{'dex' : 555, 'pokemon' : 'Darmanitan'},
{'dex' : 556, 'pokemon' : 'Maractus'},
{'dex' : 557, 'pokemon' : 'Dwebble'},
{'dex' : 558, 'pokemon' : 'Crustle'},
{'dex' : 559, 'pokemon' : 'Scraggy'},
{'dex' : 560, 'pokemon' : 'Scrafty'},
{'dex' : 561, 'pokemon' : 'Sigilyph'},
{'dex' : 562, 'pokemon' : 'Yamask'},
{'dex' : 563, 'pokemon' : 'Cofagrigus'},
{'dex' : 564, 'pokemon' : 'Tirtouga'},
{'dex' : 565, 'pokemon' : 'Carracosta'},
{'dex' : 566, 'pokemon' : 'Archen'},
{'dex' : 567, 'pokemon' : 'Archeops'},
{'dex' : 568, 'pokemon' : 'Trubbish'},
{'dex' : 569, 'pokemon' : 'Garbodor'},
{'dex' : 570, 'pokemon' : 'Zorua'},
{'dex' : 571, 'pokemon' : 'Zoroark'},
{'dex' : 572, 'pokemon' : 'Minccino'},
{'dex' : 573, 'pokemon' : 'Cinccino'},
{'dex' : 574, 'pokemon' : 'Gothita'},
{'dex' : 575, 'pokemon' : 'Gothorita'},
{'dex' : 576, 'pokemon' : 'Gothitelle'},
{'dex' : 577, 'pokemon' : 'Solosis'},
{'dex' : 578, 'pokemon' : 'Duosion'},
{'dex' : 579, 'pokemon' : 'Reuniclus'},
{'dex' : 580, 'pokemon' : 'Ducklett'},
{'dex' : 581, 'pokemon' : 'Swanna'},
{'dex' : 582, 'pokemon' : 'Vanillite'},
{'dex' : 583, 'pokemon' : 'Vanillish'},
{'dex' : 584, 'pokemon' : 'Vanilluxe'},
{'dex' : 585, 'pokemon' : 'Deerling'},
{'dex' : 586, 'pokemon' : 'Sawsbuck'},
{'dex' : 587, 'pokemon' : 'Emolga'},
{'dex' : 588, 'pokemon' : 'Karrablast'},
{'dex' : 589, 'pokemon' : 'Escavalier'},
{'dex' : 590, 'pokemon' : 'Foongus'},
{'dex' : 591, 'pokemon' : 'Amoonguss'},
{'dex' : 592, 'pokemon' : 'Frillish'},
{'dex' : 593, 'pokemon' : 'Jellicent'},
{'dex' : 594, 'pokemon' : 'Alomomola'},
{'dex' : 595, 'pokemon' : 'Joltik'},
{'dex' : 596, 'pokemon' : 'Galvantula'},
{'dex' : 597, 'pokemon' : 'Ferroseed'},
{'dex' : 598, 'pokemon' : 'Ferrothorn'},
{'dex' : 599, 'pokemon' : 'Klink'},
{'dex' : 600, 'pokemon' : 'Klang'},
{'dex' : 601, 'pokemon' : 'Klinklang'},
{'dex' : 602, 'pokemon' : 'Tynamo'},
{'dex' : 603, 'pokemon' : 'Eelektrik'},
{'dex' : 604, 'pokemon' : 'Eelektross'},
{'dex' : 605, 'pokemon' : 'Elgyem'},
{'dex' : 606, 'pokemon' : 'Beheeyem'},
{'dex' : 607, 'pokemon' : 'Litwick'},
{'dex' : 608, 'pokemon' : 'Lampent'},
{'dex' : 609, 'pokemon' : 'Chandelure'},
{'dex' : 610, 'pokemon' : 'Axew'},
{'dex' : 611, 'pokemon' : 'Fraxure'},
{'dex' : 612, 'pokemon' : 'Haxorus'},
{'dex' : 613, 'pokemon' : 'Cubchoo'},
{'dex' : 614, 'pokemon' : 'Beartic'},
{'dex' : 615, 'pokemon' : 'Cryogonal'},
{'dex' : 616, 'pokemon' : 'Shelmet'},
{'dex' : 617, 'pokemon' : 'Accelgor'},
{'dex' : 618, 'pokemon' : 'Stunfisk'},
{'dex' : 619, 'pokemon' : 'Mienfoo'},
{'dex' : 620, 'pokemon' : 'Mienshao'},
{'dex' : 621, 'pokemon' : 'Druddigon'},
{'dex' : 622, 'pokemon' : 'Golett'},
{'dex' : 623, 'pokemon' : 'Golurk'},
{'dex' : 624, 'pokemon' : 'Pawniard'},
{'dex' : 625, 'pokemon' : 'Bisharp'},
{'dex' : 626, 'pokemon' : 'Bouffalant'},
{'dex' : 627, 'pokemon' : 'Rufflet'},
{'dex' : 628, 'pokemon' : 'Braviary'},
{'dex' : 629, 'pokemon' : 'Vullaby'},
{'dex' : 630, 'pokemon' : 'Mandibuzz'},
{'dex' : 631, 'pokemon' : 'Heatmor'},
{'dex' : 632, 'pokemon' : 'Durant'},
{'dex' : 633, 'pokemon' : 'Deino'},
{'dex' : 634, 'pokemon' : 'Zweilous'},
{'dex' : 635, 'pokemon' : 'Hydreigon'},
{'dex' : 636, 'pokemon' : 'Larvesta'},
{'dex' : 637, 'pokemon' : 'Volcarona'},
{'dex' : 638, 'pokemon' : 'Cobalion'},
{'dex' : 639, 'pokemon' : 'Terrakion'},
{'dex' : 640, 'pokemon' : 'Virizion'},
{'dex' : 641, 'pokemon' : 'Tornadus'},
{'dex' : 642, 'pokemon' : 'Thundurus'},
{'dex' : 643, 'pokemon' : 'Reshiram'},
{'dex' : 644, 'pokemon' : 'Zekrom'},
{'dex' : 645, 'pokemon' : 'Landorus'},
{'dex' : 646, 'pokemon' : 'Kyurem'},
{'dex' : 647, 'pokemon' : 'Keldeo'},
{'dex' : 648, 'pokemon' : 'Meloetta'},
{'dex' : 649, 'pokemon' : 'Genesect'},
{'dex' : 650, 'pokemon' : 'Chespin'},
{'dex' : 651, 'pokemon' : 'Quilladin'},
{'dex' : 652, 'pokemon' : 'Chesnaught'},
{'dex' : 653, 'pokemon' : 'Fennekin'},
{'dex' : 654, 'pokemon' : 'Braixen'},
{'dex' : 655, 'pokemon' : 'Delphox'},
{'dex' : 656, 'pokemon' : 'Froakie'},
{'dex' : 657, 'pokemon' : 'Frogadier'},
{'dex' : 658, 'pokemon' : 'Greninja'},
{'dex' : 659, 'pokemon' : 'Bunnelby'},
{'dex' : 660, 'pokemon' : 'Diggersby'},
{'dex' : 661, 'pokemon' : 'Fletchling'},
{'dex' : 662, 'pokemon' : 'Fletchinder'},
{'dex' : 663, 'pokemon' : 'Talonflame'},
{'dex' : 664, 'pokemon' : 'Scatterbug'},
{'dex' : 665, 'pokemon' : 'Spewpa'},
{'dex' : 666, 'pokemon' : 'Vivillon'},
{'dex' : 667, 'pokemon' : 'Litleo'},
{'dex' : 668, 'pokemon' : 'Pyroar'},
{'dex' : 669, 'pokemon' : 'Flabébé'},
{'dex' : 670, 'pokemon' : 'Floette'},
{'dex' : 671, 'pokemon' : 'Florges'},
{'dex' : 672, 'pokemon' : 'Skiddo'},
{'dex' : 673, 'pokemon' : 'Gogoat'},
{'dex' : 674, 'pokemon' : 'Pancham'},
{'dex' : 675, 'pokemon' : 'Pangoro'},
{'dex' : 676, 'pokemon' : 'Furfrou'},
{'dex' : 677, 'pokemon' : 'Espurr'},
{'dex' : 678, 'pokemon' : 'Meowstic'},
{'dex' : 679, 'pokemon' : 'Honedge'},
{'dex' : 680, 'pokemon' : 'Doublade'},
{'dex' : 681, 'pokemon' : 'Aegislash'},
{'dex' : 682, 'pokemon' : 'Spritzee'},
{'dex' : 683, 'pokemon' : 'Aromatisse'},
{'dex' : 684, 'pokemon' : 'Swirlix'},
{'dex' : 685, 'pokemon' : 'Slurpuff'},
{'dex' : 686, 'pokemon' : 'Inkay'},
{'dex' : 687, 'pokemon' : 'Malamar'},
{'dex' : 688, 'pokemon' : 'Binacle'},
{'dex' : 689, 'pokemon' : 'Barbaracle'},
{'dex' : 690, 'pokemon' : 'Skrelp'},
{'dex' : 691, 'pokemon' : 'Dragalge'},
{'dex' : 692, 'pokemon' : 'Clauncher'},
{'dex' : 693, 'pokemon' : 'Clawitzer'},
{'dex' : 694, 'pokemon' : 'Helioptile'},
{'dex' : 695, 'pokemon' : 'Heliolisk'},
{'dex' : 696, 'pokemon' : 'Tyrunt'},
{'dex' : 697, 'pokemon' : 'Tyrantrum'},
{'dex' : 698, 'pokemon' : 'Amaura'},
{'dex' : 699, 'pokemon' : 'Aurorus'},
{'dex' : 700, 'pokemon' : 'Sylveon'},
{'dex' : 701, 'pokemon' : 'Hawlucha'},
{'dex' : 702, 'pokemon' : 'Dedenne'},
{'dex' : 703, 'pokemon' : 'Carbink'},
{'dex' : 704, 'pokemon' : 'Goomy'},
{'dex' : 705, 'pokemon' : 'Sliggoo'},
{'dex' : 706, 'pokemon' : 'Goodra'},
{'dex' : 707, 'pokemon' : 'Klefki'},
{'dex' : 708, 'pokemon' : 'Phantump'},
{'dex' : 709, 'pokemon' : 'Trevenant'},
{'dex' : 710, 'pokemon' : 'Pumpkaboo'},
{'dex' : 711, 'pokemon' : 'Gourgeist'},
{'dex' : 712, 'pokemon' : 'Bergmite'},
{'dex' : 713, 'pokemon' : 'Avalugg'},
{'dex' : 714, 'pokemon' : 'Noibat'},
{'dex' : 715, 'pokemon' : 'Noivern'},
{'dex' : 716, 'pokemon' : 'Xerneas'},
{'dex' : 717, 'pokemon' : 'Yveltal'},
{'dex' : 718, 'pokemon' : 'Zygarde'},
{'dex' : 719, 'pokemon' : 'Diancie'},
{'dex' : 720, 'pokemon' : 'Hoopa'},
{'dex' : 721, 'pokemon' : 'Volcanion'},
{'dex' : 722, 'pokemon' : 'Rowlet'},
{'dex' : 723, 'pokemon' : 'Dartrix'},
{'dex' : 724, 'pokemon' : 'Decidueye'},
{'dex' : 725, 'pokemon' : 'Litten'},
{'dex' : 726, 'pokemon' : 'Torracat'},
{'dex' : 727, 'pokemon' : 'Incineroar'},
{'dex' : 728, 'pokemon' : 'Popplio'},
{'dex' : 729, 'pokemon' : 'Brionne'},
{'dex' : 730, 'pokemon' : 'Primarina'},
{'dex' : 731, 'pokemon' : 'Pikipek'},
{'dex' : 732, 'pokemon' : 'Trumbeak'},
{'dex' : 733, 'pokemon' : 'Toucannon'},
{'dex' : 734, 'pokemon' : 'Yungoos'},
{'dex' : 735, 'pokemon' : 'Gumshoos'},
{'dex' : 736, 'pokemon' : 'Grubbin'},
{'dex' : 737, 'pokemon' : 'Charjabug'},
{'dex' : 738, 'pokemon' : 'Vikavolt'},
{'dex' : 739, 'pokemon' : 'Crabrawler'},
{'dex' : 740, 'pokemon' : 'Crabominable'},
{'dex' : 741, 'pokemon' : 'Oricorio'},
{'dex' : 742, 'pokemon' : 'Cutiefly'},
{'dex' : 743, 'pokemon' : 'Ribombee'},
{'dex' : 744, 'pokemon' : 'Rockruff'},
{'dex' : 745, 'pokemon' : 'Lycanroc'},
{'dex' : 746, 'pokemon' : 'Wishiwashi'},
{'dex' : 747, 'pokemon' : 'Mareanie'},
{'dex' : 748, 'pokemon' : 'Toxapex'},
{'dex' : 749, 'pokemon' : 'Mudbray'},
{'dex' : 750, 'pokemon' : 'Mudsdale'},
{'dex' : 751, 'pokemon' : 'Dewpider'},
{'dex' : 752, 'pokemon' : 'Araquanid'},
{'dex' : 753, 'pokemon' : 'Fomantis'},
{'dex' : 754, 'pokemon' : 'Lurantis'},
{'dex' : 755, 'pokemon' : 'Morelull'},
{'dex' : 756, 'pokemon' : 'Shiinotic'},
{'dex' : 757, 'pokemon' : 'Salandit'},
{'dex' : 758, 'pokemon' : 'Salazzle'},
{'dex' : 759, 'pokemon' : 'Stufful'},
{'dex' : 760, 'pokemon' : 'Bewear'},
{'dex' : 761, 'pokemon' : 'Bounsweet'},
{'dex' : 762, 'pokemon' : 'Steenee'},
{'dex' : 763, 'pokemon' : 'Tsareena'},
{'dex' : 764, 'pokemon' : 'Comfey'},
{'dex' : 765, 'pokemon' : 'Oranguru'},
{'dex' : 766, 'pokemon' : 'Passimian'},
{'dex' : 767, 'pokemon' : 'Wimpod'},
{'dex' : 768, 'pokemon' : 'Golisopod'},
{'dex' : 769, 'pokemon' : 'Sandygast'},
{'dex' : 770, 'pokemon' : 'Palossand'},
{'dex' : 771, 'pokemon' : 'Pyukumuku'},
{'dex' : 772, 'pokemon' : 'Type: Null'},
{'dex' : 773, 'pokemon' : 'Silvally'},
{'dex' : 774, 'pokemon' : 'Minior'},
{'dex' : 775, 'pokemon' : 'Komala'},
{'dex' : 776, 'pokemon' : 'Turtonator'},
{'dex' : 777, 'pokemon' : 'Togedemaru'},
{'dex' : 778, 'pokemon' : 'Mimikyu'},
{'dex' : 779, 'pokemon' : 'Bruxish'},
{'dex' : 780, 'pokemon' : 'Drampa'},
{'dex' : 781, 'pokemon' : 'Dhelmise'},
{'dex' : 782, 'pokemon' : 'Jangmo-o'},
{'dex' : 783, 'pokemon' : 'Hakamo-o'},
{'dex' : 784, 'pokemon' : 'Kommo-o'},
{'dex' : 785, 'pokemon' : 'Tapu Koko'},
{'dex' : 786, 'pokemon' : 'Tapu Lele'},
{'dex' : 787, 'pokemon' : 'Tapu Bulu'},
{'dex' : 788, 'pokemon' : 'Tapu Fini'},
{'dex' : 789, 'pokemon' : 'Cosmog'},
{'dex' : 790, 'pokemon' : 'Cosmoem'},
{'dex' : 791, 'pokemon' : 'Solgaleo'},
{'dex' : 792, 'pokemon' : 'Lunala'},
{'dex' : 793, 'pokemon' : 'Nihilego'},
{'dex' : 794, 'pokemon' : 'Buzzwole'},
{'dex' : 795, 'pokemon' : 'Pheromosa'},
{'dex' : 796, 'pokemon' : 'Xurkitree'},
{'dex' : 797, 'pokemon' : 'Celesteela'},
{'dex' : 798, 'pokemon' : 'Kartana'},
{'dex' : 799, 'pokemon' : 'Guzzlord'},
{'dex' : 800, 'pokemon' : 'Necrozma'},
{'dex' : 801, 'pokemon' : 'Magearna'},
{'dex' : 802, 'pokemon' : 'Marshadow'},
{'dex' : 803, 'pokemon' : 'Poipole'},
{'dex' : 804, 'pokemon' : 'Naganadel'},
{'dex' : 805, 'pokemon' : 'Stakataka'},
{'dex' : 806, 'pokemon' : 'Blacephalon'},
{'dex' : 807, 'pokemon' : 'Zeraora'},
{'dex' : 808, 'pokemon' : 'Meltan'},
{'dex' : 809, 'pokemon' : 'Melmetal'},
{'dex' : 810, 'pokemon' : 'Grookey'},
{'dex' : 811, 'pokemon' : 'Thwackey'},
{'dex' : 812, 'pokemon' : 'Rillaboom'},
{'dex' : 813, 'pokemon' : 'Scorbunny'},
{'dex' : 814, 'pokemon' : 'Raboot'},
{'dex' : 815, 'pokemon' : 'Cinderace'},
{'dex' : 816, 'pokemon' : 'Sobble'},
{'dex' : 817, 'pokemon' : 'Drizzile'},
{'dex' : 818, 'pokemon' : 'Inteleon'},
{'dex' : 819, 'pokemon' : 'Skwovet'},
{'dex' : 820, 'pokemon' : 'Greedent'},
{'dex' : 821, 'pokemon' : 'Rookidee'},
{'dex' : 822, 'pokemon' : 'Corvisquire'},
{'dex' : 823, 'pokemon' : 'Corviknight'},
{'dex' : 824, 'pokemon' : 'Blipbug'},
{'dex' : 825, 'pokemon' : 'Dottler'},
{'dex' : 826, 'pokemon' : 'Orbeetle'},
{'dex' : 827, 'pokemon' : 'Nickit'},
{'dex' : 828, 'pokemon' : 'Thievul'},
{'dex' : 829, 'pokemon' : 'Gossifleur'},
{'dex' : 830, 'pokemon' : 'Eldegoss'},
{'dex' : 831, 'pokemon' : 'Wooloo'},
{'dex' : 832, 'pokemon' : 'Dubwool'},
{'dex' : 833, 'pokemon' : 'Chewtle'},
{'dex' : 834, 'pokemon' : 'Drednaw'},
{'dex' : 835, 'pokemon' : 'Yamper'},
{'dex' : 836, 'pokemon' : 'Boltund'},
{'dex' : 837, 'pokemon' : 'Rolycoly'},
{'dex' : 838, 'pokemon' : 'Carkol'},
{'dex' : 839, 'pokemon' : 'Coalossal'},
{'dex' : 840, 'pokemon' : 'Applin'},
{'dex' : 841, 'pokemon' : 'Flapple'},
{'dex' : 842, 'pokemon' : 'Appletun'},
{'dex' : 843, 'pokemon' : 'Silicobra'},
{'dex' : 844, 'pokemon' : 'Sandaconda'},
{'dex' : 845, 'pokemon' : 'Cramorant'},
{'dex' : 846, 'pokemon' : 'Arrokuda'},
{'dex' : 847, 'pokemon' : 'Barraskewda'},
{'dex' : 848, 'pokemon' : 'Toxel'},
{'dex' : 849, 'pokemon' : 'Toxtricity'},
{'dex' : 850, 'pokemon' : 'Sizzlipede'},
{'dex' : 851, 'pokemon' : 'Centiskorch'},
{'dex' : 852, 'pokemon' : 'Clobbopus'},
{'dex' : 853, 'pokemon' : 'Grapploct'},
{'dex' : 854, 'pokemon' : 'Sinistea'},
{'dex' : 855, 'pokemon' : 'Polteageist'},
{'dex' : 856, 'pokemon' : 'Hatenna'},
{'dex' : 857, 'pokemon' : 'Hattrem'},
{'dex' : 858, 'pokemon' : 'Hatterene'},
{'dex' : 859, 'pokemon' : 'Impidimp'},
{'dex' : 860, 'pokemon' : 'Morgrem'},
{'dex' : 861, 'pokemon' : 'Grimmsnarl'},
{'dex' : 862, 'pokemon' : 'Obstagoon'},
{'dex' : 863, 'pokemon' : 'Perrserker'},
{'dex' : 864, 'pokemon' : 'Cursola'},
{'dex' : 865, 'pokemon' : 'Sirfetch’d'},
{'dex' : 866, 'pokemon' : 'Mr. Rime'},
{'dex' : 867, 'pokemon' : 'Runerigus'},
{'dex' : 868, 'pokemon' : 'Milcery'},
{'dex' : 869, 'pokemon' : 'Alcremie'},
{'dex' : 870, 'pokemon' : 'Falinks'},
{'dex' : 871, 'pokemon' : 'Pincurchin'},
{'dex' : 872, 'pokemon' : 'Snom'},
{'dex' : 873, 'pokemon' : 'Frosmoth'},
{'dex' : 874, 'pokemon' : 'Stonjourner'},
{'dex' : 875, 'pokemon' : 'Eiscue'},
{'dex' : 876, 'pokemon' : 'Indeedee'},
{'dex' : 877, 'pokemon' : 'Morpeko'},
{'dex' : 878, 'pokemon' : 'Cufant'},
{'dex' : 879, 'pokemon' : 'Copperajah'},
{'dex' : 880, 'pokemon' : 'Dracozolt'},
{'dex' : 881, 'pokemon' : 'Arctozolt'},
{'dex' : 882, 'pokemon' : 'Dracovish'},
{'dex' : 883, 'pokemon' : 'Arctovish'},
{'dex' : 884, 'pokemon' : 'Duraludon'},
{'dex' : 885, 'pokemon' : 'Dreepy'},
{'dex' : 886, 'pokemon' : 'Drakloak'},
{'dex' : 887, 'pokemon' : 'Dragapult'},
{'dex' : 888, 'pokemon' : 'Zacian'},
{'dex' : 889, 'pokemon' : 'Zamazenta'},
{'dex' : 890, 'pokemon' : 'Eternatus'},
{'dex' : 891, 'pokemon' : 'Kubfu'},
{'dex' : 892, 'pokemon' : 'Urshifu'},
{'dex' : 893, 'pokemon' : 'Zarude'},
{'dex' : 894, 'pokemon' : 'Regieleki'},
{'dex' : 895, 'pokemon' : 'Regidrago'},
{'dex' : 896, 'pokemon' : 'Glastrier'},
{'dex' : 897, 'pokemon' : 'Spectrier'},
{'dex' : 898, 'pokemon' : 'Calyrex'},
]

export default NatDex;